"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationSupervisionTeam',
  data: function data() {
    return {
      loading: false,
      list: [],
      projects: []
    };
  },
  created: function created() {
    var _this = this;
    this.reload();
    (0, _decoration.decorationSiteBasicListApi)({
      page: 1,
      limit: 20
    }).then(function (data) {
      _this.projects = data.list || [];
    }).catch(function () {});
  },
  methods: {
    actionText: function actionText(value) {
      return {
        leave: '离队',
        set_primary: '设主责'
      }[value] || value;
    },
    reload: function reload() {
      var _this2 = this;
      this.loading = true;
      (0, _decoration.decorationSupervisionTeamListApi)({
        page: 1,
        limit: 50,
        status: 'active'
      }).then(function (data) {
        _this2.list = data.list || [];
      }).finally(function () {
        _this2.loading = false;
      });
    },
    openCreate: function openCreate() {
      var _this3 = this;
      var project = this.projects[0] && this.projects[0].project;
      if (!project) {
        this.$message.warning('暂无工地');
        return;
      }
      (0, _decoration.decorationSupervisionTeamSaveApi)({
        projectId: project.id,
        staffId: 2,
        projectRole: 'supervisor'
      }).then(function () {
        _this3.$message.success('已保存');
        _this3.reload();
      });
    },
    runAction: function runAction(row, action) {
      var _this4 = this;
      (0, _decoration.decorationSupervisionTeamActionApi)(row.member.id, {
        action: action
      }).then(function () {
        _this4.$message.success('已更新');
        _this4.reload();
      });
    }
  }
};